import { useEffect, useRef } from "react";
import io from "socket.io-client";
import { toast } from "sonner";

export const useSocket = () => {
  const socketRef = useRef(null);

  const connectSocket = (userId) => {
    if (!socketRef.current) {
      socketRef.current = io(`${process.env.REACT_APP_API_URL}`, {
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      });

      socketRef.current.on("connect", () => {
        console.log("Socket connected:", socketRef.current.id);
        socketRef.current.emit("join", { userId });
      });
      

      socketRef.current.on("connect_error", (error) => {
        console.error("Socket connection error:", error);
        toast.error("Failed to connect to real-time server");
      });

      // Urgent staff request events
      socketRef.current.on("newUrgentRequest", (data) => {
        toast.info(`New urgent request for ${data.position}`);
        // Update UI or store as needed
      });

      socketRef.current.on("acceptanceUpdate", (data) => {
        toast.info(`Job seeker accepted request ${data.requestId}`);
        // Update UI
      });

      socketRef.current.on("requestCancelled", (data) => {
        toast.info(data.message);
        // Update UI
      });

      socketRef.current.on("acceptanceCancelled", (data) => {
        toast.info(data.message);
        // Update UI
      });

      socketRef.current.on("selectionUpdate", (data) => {
        toast.info(`Job seeker selected for request ${data.requestId}`);
        // Update UI
      });

      socketRef.current.on("paymentUpdate", (data) => {
        toast.success(`Request ${data.requestId} assigned. Chat/call enabled.`);
        // Update UI with phone number for fallback
      });

      socketRef.current.on("adminAllocation", (data) => {
        toast.success(`Assigned to request ${data.requestId} by admin`);
        // Update UI
      });

      socketRef.current.on("newMessage", (msg) => {
        toast.info(`New message for request ${msg.requestId}`);
        // Update chat UI
      });

      socketRef.current.on("callOffer", (data) => {
        toast.info(`Incoming call for request ${data.requestId}`);
        // Handle WebRTC call setup
      });

      socketRef.current.on("error", (data) => {
        toast.error(data.message);
      });
    }
  };

  const disconnectSocket = () => {
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
    }
  };

  return { connectSocket, disconnectSocket, socket: socketRef.current };
};